const COMMON_TYPES = {
  // URL
  URL_SET_LOAN_PARAMS: 'URL@@SET_LOAN_PARAMS',
  URL_SET_ALL_PARAM: 'URL@@SET_ALL_PARAMS',
  URL_SET_ATTACH_PARAMS: 'URL@@SET_ATTACH_PARAMS',

  // LoanSummary
  SET_LOAN_SUMMARY_UPSERT_OR_DELETE: 'SET_LOAN_SUMMARY_UPSERT_OR_DELETE',
};

export default COMMON_TYPES;
